import React from "react";
import { sanitizeProgressMessage, schemaJobStatusLabel } from "./schemaOptimizerUtils";

const STEPS = [
	{ key: "PENDING", label: "Queued", matchers: [/^pending$/i, /queued/i] },
	{ key: "SCRAPING", label: "Scrape page", matchers: [/scrap/i, /fetch/i, /flaresolverr/i] },
	{ key: "CLASSIFYING", label: "Classify vertical", matchers: [/classif/i] },
	{ key: "GENERATING", label: "Generate JSON-LD", matchers: [/generat/i] },
	{
		key: "BATCH",
		label: "Batch processing",
		matchers: [/batch/i],
		optional: true,
	},
	{ key: "VALIDATING", label: "SHACL validate", matchers: [/validat/i, /shacl/i] },
];

function stepIndexFromStatus(status, progressMessage) {
	const statusKey = String(status || "").toUpperCase();
	const msg = String(progressMessage || "").toLowerCase();

	if (statusKey === "SUCCESS") return STEPS.length;

	const direct = STEPS.findIndex((s) => s.key === statusKey);
	if (direct >= 0) return direct;

	for (let i = STEPS.length - 1; i >= 0; i -= 1) {
		if (STEPS[i].matchers.some((m) => m.test(msg) || m.test(statusKey))) return i;
	}
	return 0;
}

export default function SchemaOptimizerPipelineSteps({ status, progressMessage, useBatchApi }) {
	const steps = useBatchApi ? STEPS : STEPS.filter((s) => s.key !== "BATCH");
	const currentIdx = stepIndexFromStatus(status, progressMessage);
	const allComplete = currentIdx >= steps.length;

	return (
		<ol className="schema-optimizer__pipeline-steps list-unstyled mb-0">
			{steps.map((step, index) => {
				const isComplete = allComplete || currentIdx > index;
				const isCurrent = !allComplete && currentIdx === index;
				let stepClass = "schema-optimizer__pipeline-step schema-optimizer__pipeline-step--pending";
				if (isComplete) stepClass += " schema-optimizer__pipeline-step--complete";
				else if (isCurrent) stepClass += " schema-optimizer__pipeline-step--current";

				return (
					<li key={step.key} className={stepClass}>
						<span className="schema-optimizer__pipeline-step-icon" aria-hidden>
							{isComplete ? (
								<i className="fas fa-check" />
							) : isCurrent ? (
								<span className="schema-optimizer__pipeline-dot" />
							) : (
								<span className="schema-optimizer__pipeline-dot schema-optimizer__pipeline-dot--muted" />
							)}
						</span>
						<span className="schema-optimizer__pipeline-step-label">{step.label}</span>
					</li>
				);
			})}
		</ol>
	);
}

export function processingTitle(status, progressMessage) {
	const raw = String(progressMessage || "").trim();
	if (raw) {
		if (/flaresolverr/i.test(raw) || /^fetching https?:\/\//i.test(raw)) {
			return "Fetching page content…";
		}
		const msg = sanitizeProgressMessage(raw);
		if (msg.length > 100) return `${msg.slice(0, 97)}…`;
		return msg;
	}
	return schemaJobStatusLabel(status) || "Processing…";
}

export function processingDetailMessage(status, progressMessage) {
	const raw = String(progressMessage || "").trim();
	if (!raw) return null;
	const title = processingTitle(status, progressMessage);
	const sanitized = sanitizeProgressMessage(raw);
	if (title === sanitized) return null;
	if (/flaresolverr/i.test(raw) || /^fetching https?:\/\//i.test(raw)) {
		return raw;
	}
	return null;
}
